import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private SECRET_KEY = '$wbE(b84H93+C|r;Rh0)jO9jCdy2I6p0KL';

  setSecureCookie(name: string, data: any, days: number = 1) {
    const encryptedData = this.encrypt(JSON.stringify(data));
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 1 * 60 * 60 * 1000);

    document.cookie = `${name}=${encryptedData}; expires=${expires.toUTCString()}; path=/; domain=${
      environment.domain
    };`;
  }

  getSecureCookie(name: string): any {
    const cookieArr = document.cookie.split(';');
    const cookieValue = cookieArr
      .find((cookie) => cookie.trim().startsWith(`${name}=`))
      ?.split('=')[1];

    if (cookieValue) {
      try {
        const decryptedData = this.decrypt(cookieValue);
        return JSON.parse(decryptedData);
      } catch (error) {
        console.error('Erro ao descriptografar cookie');
        return null;
      }
    }
    return null;
  }

  private encrypt(data: string): string {
    return CryptoJS.AES.encrypt(data, this.SECRET_KEY).toString();
  }

  private decrypt(encryptedData: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  deleteSecureCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
